var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.qma === 0)?_c('inqueryQmaLvTable',{ref:"inqueryQmaLvTable",attrs:{"qma":_vm.qma}}):_vm._e(),_vm._v(" "),(_vm.qma === 1)?_c('inqueryQmaPitTable',{ref:"inqueryQmaPitTable",attrs:{"qma":_vm.qma}}):_vm._e(),_vm._v(" "),(_vm.qma === 2)?_c('inqueryQmaPivsTable',{ref:"tableInqueryQmaPivs",attrs:{"qma":_vm.qma}}):_vm._e()],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc3b6214","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/private/qma/inqueryQma/components/inqueryQmaTable/inqueryQmaTable.vue
// module id = null
// module chunks = 